module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_16-86873d936265071848dc4aa0fef89b7e.jpg";